import { render, staticRenderFns } from "./pts.vue?vue&type=template&id=74e50d73&"
import script from "./pts.vue?vue&type=script&lang=js&"
export * from "./pts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports